<template>
  <div class="d-flex mt-4 mb-4" style="max-width: 950px">
      <span>
        *
      </span>
    <span class="ml-1 ">
        Podatek velja samo za odjave prek portala MOJ T-2.
        Informacije o drugih načinih odjave so na voljo v pogodbeni dokumentaciji, na telefonski
        številki 064 064 064, info@t-2.net ali v poslovalnicah T-2.
      </span>
  </div>
</template>
<script>
export default {
  name: 'InfoKomponentaOdjavaOpozorilo'
}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Naroci/NarociTelevizija/InfoKomponentaOdjavaOpozorilo.vue